import { render, staticRenderFns } from "./ReasonList.vue?vue&type=template&id=5ade88e1&scoped=true&"
import script from "./ReasonList.vue?vue&type=script&lang=js&"
export * from "./ReasonList.vue?vue&type=script&lang=js&"
import style0 from "./ReasonList.vue?vue&type=style&index=0&id=5ade88e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ade88e1",
  null
  
)

export default component.exports